export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const GET_ALL_USER = 'GET_ALL_USER'
export const LOADING_USER = 'LOADING_USER'